import { AvailableSmartAssistantImportDTO, SmartAssistantImportSummaryDTO } from '@iota/inh-core-v1-management-client';
import { SmartTableHeaderAndData, SmartTableRow } from 'src/app/shared/components/smart-table/smart-table.component';
import { CompanyMode } from 'src/app/shared/constants-and-enums/company-mode.enum';
import {
    SMART_ASSISTANT_STATUS_BADGE_CONFIG,
    SMART_ASSISTANT_TYPE_CONFIGS,
    SmartAssistantOwner,
    SmartAssistantTile
} from 'src/app/shared/constants-and-enums/smart-assistant-types';
import { formatDate } from 'src/app/shared/utils';

export function toSmartAssistantOwner(mode: CompanyMode | undefined): SmartAssistantOwner {
    return mode === CompanyMode.PARTNER ? 'SOLUTION_PARTNER' : 'COMPANY';
}

export function toSmartAssistantTiles(availableImports: AvailableSmartAssistantImportDTO[]): SmartAssistantTile[] {
    return availableImports.flatMap((availableImport) => {
        const typeConfig = SMART_ASSISTANT_TYPE_CONFIGS[availableImport.type];
        return typeConfig ? [{ availableImport, cardTitle: typeConfig.cardTitle, cardSubtitle: typeConfig.cardSubtitle }] : [];
    });
}

export function toSmartAssistantReportsTable(imports: SmartAssistantImportSummaryDTO[]): SmartTableHeaderAndData {
    const headers = [
        { key: 'type', label: $localize`Smart Assistant` },
        { key: 'dateTime', label: $localize`Date / Time` },
        { key: 'user', label: $localize`User` },
        { key: 'status', label: $localize`Status` },
        { key: 'changes', label: $localize`Changes` },
        { key: 'actions', label: $localize`Processing Report` }
    ];

    const rows: SmartTableRow[] = (imports ?? []).map((item) => {
        const typeConfig = SMART_ASSISTANT_TYPE_CONFIGS[item.type];
        const statusConfig = SMART_ASSISTANT_STATUS_BADGE_CONFIG[item.status];
        const statusLabel = statusConfig?.label ?? item.status;
        return {
            type: { data: typeConfig?.cardTitle ?? item.type },
            dateTime: {
                data: formatDate(item.creationDateTime, 'DD.MM.YYYY HH:mm') ?? '',
                rawData: item.creationDateTime,
                isDate: true
            },
            user: { data: item.createdBy ?? '' },
            status: {
                rawData: { label: statusLabel, color: statusConfig?.color ?? 'neutral' },
                sortValue: statusLabel
            },
            changes: { data: item.processedEntries?.toString() ?? '0' },
            actions: { data: '', rawData: item.id }
        };
    });

    return { headers, rows };
}
